import { render, staticRenderFns } from "./AuthorPopup.vue?vue&type=template&id=7f87bdd4&"
import script from "./AuthorPopup.vue?vue&type=script&lang=js&"
export * from "./AuthorPopup.vue?vue&type=script&lang=js&"
import style0 from "./AuthorPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports